export const LEGAL_DOCS = {
  privacy: {
    title: "Informativa sulla Privacy",
    updated: "Ultimo aggiornamento: 23 ottobre 2026",
    sections: [
      {
        h: "1. Titolare del trattamento",
        p: "Titolare del trattamento dei dati personali è RV FILM Italia srl, con sede in Via U. Braschi 8 int. 3, 47822 Santarcangelo di Romagna (RN), Italia, nella persona del legale rappresentante Marco Ballerini. Per qualsiasi richiesta relativa alla privacy è possibile scrivere a info@rvfilm.it.",
      },
      {
        h: "2. Dati personali raccolti",
        p: "Attraverso il form contatti raccogliamo: nome e cognome, indirizzo email, nome dell'azienda, servizio di interesse, budget indicativo e testo del messaggio. Durante la navigazione vengono inoltre registrati automaticamente dati tecnici (indirizzo IP, tipo di browser, data e ora di visita) nei log di sicurezza del sito. Per l'accesso all'area riservata degli amministratori vengono trattati i dati dell'account Google utilizzato (nome, email, foto profilo).",
      },
      {
        h: "3. Finalità e base giuridica",
        p: "I dati inviati tramite il form contatti sono trattati per rispondere alle richieste ricevute ed elaborare preventivi (art. 6, par. 1, lett. b GDPR — esecuzione di misure precontrattuali). I dati tecnici di navigazione sono trattati per garantire la sicurezza e il corretto funzionamento del sito (art. 6, par. 1, lett. f GDPR — legittimo interesse). Le statistiche di navigazione aggregate sono trattate solo previo consenso espresso tramite il banner cookie (art. 6, par. 1, lett. a GDPR).",
      },
      {
        h: "4. Conservazione dei dati",
        p: "Le richieste inviate tramite il form sono conservate per il tempo necessario alla gestione della richiesta e comunque non oltre 24 mesi. I log di sicurezza sono conservati per 7 giorni. Le sessioni dell'area riservata hanno durata di 7 giorni.",
      },
      {
        h: "5. Comunicazione a terzi",
        p: "I dati possono essere trattati da fornitori tecnici che operano come responsabili del trattamento (provider di hosting e infrastruttura cloud, servizio di invio email transazionale, Google per l'autenticazione dell'area riservata). I dati non sono mai ceduti a terzi per finalità di marketing né diffusi.",
      },
      {
        h: "6. I tuoi diritti",
        p: "Ai sensi degli artt. 15-22 del GDPR puoi esercitare in qualsiasi momento i diritti di accesso, rettifica, cancellazione, limitazione del trattamento, opposizione e portabilità dei dati scrivendo a info@rvfilm.it. Hai inoltre diritto di proporre reclamo all'Autorità di controllo (Garante per la protezione dei dati personali — www.garanteprivacy.it).",
      },
      {
        h: "7. Misure di sicurezza",
        p: "Il sito tratta i dati in maniera lecita e corretta, adottando misure di sicurezza tecniche e organizzative adeguate a impedire accessi non autorizzati, divulgazione, modifica o distruzione non autorizzata dei dati. Le comunicazioni avvengono esclusivamente su connessione cifrata (HTTPS).",
      },
    ],
  },
  cookies: {
    title: "Cookie Policy",
    updated: "Ultimo aggiornamento: 23 ottobre 2026",
    sections: [
      {
        h: "1. Cosa sono i cookie",
        p: "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi allo stesso sito alla visita successiva. Questo sito utilizza cookie tecnici e, previo consenso, strumenti di analisi aggregata.",
      },
      {
        h: "2. Cookie tecnici (necessari, senza consenso)",
        p: "session_token: cookie di sessione httpOnly per l'accesso all'area riservata, durata 7 giorni. Preferenza lingua (IT/EN): salvata nel browser. rvfilm-cookie-consent: memorizza la scelta espressa nel banner cookie, durata 12 mesi. Questi strumenti sono strettamente necessari al funzionamento del sito e non richiedono consenso.",
      },
      {
        h: "3. Strumenti di analisi (con consenso)",
        p: "Il sito utilizza PostHog per statistiche di navigazione aggregate (pagine visitate, interazioni). Lo strumento è disattivato per impostazione predefinita e viene attivato solo dopo il consenso espresso tramite il banner. Puoi revocare il consenso in qualsiasi momento dal pulsante in fondo a questa pagina.",
      },
      {
        h: "4. Servizi di terze parti",
        p: "Alcune pagine incorporano video YouTube (Google Ireland Ltd.): alla riproduzione volontaria del video YouTube può impostare cookie propri e raccogliere dati di utilizzo secondo la propria informativa (policies.google.com/privacy). L'autenticazione dell'area riservata avviene tramite Google OAuth.",
      },
      {
        h: "5. Gestione e disabilitazione dei cookie",
        p: "Puoi modificare la tua scelta sui cookie in qualsiasi momento con il pulsante qui sotto, oppure disabilitare i cookie direttamente dalle impostazioni del browser (Chrome, Firefox, Safari, Edge). La disabilitazione dei cookie tecnici può compromettere alcune funzionalità del sito.",
      },
    ],
  },
};
